import request from '@/utils/request'

let exportStatusStatistics=(data)=>request.post('/api/statusHistory/export',data)
let getImeiSingleStatusStatistics=(data)=>request.post('/api/statusHistory/listByImei',data)


export default {
  exportStatusStatistics,
  getImeiSingleStatusStatistics
}